module.exports = __webpack_public_path__ + "img/sync.7ccdb0cc.svg";